import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

// based on https://icons.app.sbb.ch/kom/chevron-small-up-small.svg
export const ChevronSmallUp: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <polyline fill="none" stroke={iconColor} points="15.9 13.675 11.996 9.725 8.092 13.674" />
    </svg>
  );
};
